/* tslint:disable */
/* eslint-disable */
export enum WorkProjectDurationOverrunStatusEnum {
  Disabled = 'DISABLED',
  NotStarted = 'NOT_STARTED',
  Within = 'WITHIN',
  Overrun = 'OVERRUN',
  Billed = 'BILLED'
}
